import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { Checkbox } from '@pwc/appkit-react/lib/Checkbox';

class CheckboxCellRenderer extends PureComponent {
  static propTypes = {
    isChecked: PropTypes.func.isRequired,
    isDisabled: PropTypes.func,
    onSelect: PropTypes.func,
    data: PropTypes.shape({}).isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  };

  static defaultProps = {
    isDisabled: () => false,
  };

  refresh() {
    this.forceUpdate();
    return true;
  }

  render() {
    const {
      value,
      isDisabled,
      data,
      isChecked,
      onSelect,
    } = this.props;

    const checked = isChecked(value);
    const disabled = isDisabled(value);
    const select = () => {
      onSelect(value, data);
    };

    return (
      <Checkbox
        onChange={select} // eslint-disable-line react/jsx-no-bind
        checked={checked}
        disabled={disabled}
      />
    );
  }
}

export default () => props => <CheckboxCellRenderer {...props} />; // eslint-disable-line react/display-name
